export const termsTranslations = {
  TERMS_TITLE: 'Terms & Conditions',
  TERMS_SUBTITLE: 'version',
};
